import { render } from "./LockPageIcon.vue?vue&type=template&id=932c6d78"
import script from "./LockPageIcon.vue?vue&type=script&lang=js"
export * from "./LockPageIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__